import { newE2EPage } from '@stencil/core/testing';

describe('social-share-list', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<social-share-list></social-share-list>');

    const element = await page.find('social-share-list');
    expect(element).toHaveClass('hydrated');
  });
});
